import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lookupName' })
export class LookupNamePipe implements PipeTransform {
  transform<K>(id: K | null | undefined, names: ReadonlyMap<K, string> | null | undefined, fallback = ''): string {
    return id == null ? fallback : (names?.get(id) ?? fallback);
  }
}
